import { getOriginalEvent } from 'owa-calendar-compose-store-manager';
import { FluidOwaSource } from 'owa-fluid-validations';
import { lazyIsCollabEnabledInEvent } from 'owa-calendar-collaborative-space-utils';
import { isMeetingOnCalendarSharedWithMe } from 'owa-calendar-event-capabilities';

export async function showExistingCollabSpaceForDelegate(formId: string) {
    // Here we need to use the originalEvent because collab space can be added to the event in compose
    // when you navigate to SA in primary calendar before trying to switch to a delegate calendar.
    const originalEvent = getOriginalEvent(formId);
    if (originalEvent.CollabSpace) {
        return (
            (await lazyIsCollabEnabledInEvent.importAndExecute(
                originalEvent,
                FluidOwaSource.CalendarCompose
            )) && isMeetingOnCalendarSharedWithMe(originalEvent)
        );
    }
    return false;
}
